// data/partenaires2026.js
// Partenaires & sponsors de l'édition 2026 (7e édition).
//
// Champs :
//   - logo      : chemin dans public/assets/partners/2026/, ou null si pas
//                 encore de logo (le nom du partenaire s'affiche à la place)
//   - lien      : null s'il n'y a pas de site web
//   - categorie : "institutionnel" (collectivités, institutions...) ou
//                 "prive" (commerçants, artisans, entreprises...).
//                 Si absent, le partenaire est considéré comme privé.
export const partenaires2026 = [
  {
    nom: "Département de Maine et Loire",
    logo: "/assets/partners/2026/Departement_Anjou_cmjn.webp",
    lien: "https://www.maine-et-loire.fr",
    categorie: "institutionnel",
  },
  {
    nom: "Fonds pour le Développement de la vie Associative",
    logo: "/assets/partners/2026/Logo-Fonds-de-developpement-de-la-vie-associative-FDVA.webp",
    lien: "https://associations.gouv.fr/fonds-pour-le-developpement-de-la-vie-associative-fdva",
    categorie: "institutionnel",
  },

  {
    nom: "Bricomarché",
    logo: "/assets/partners/2026/Bricomarche_logo_2022.svg.webp",
    lien: "https://www.bricomarche.com/magasin/brissac-quince/20320",
    categorie: "prive",
  },
  {
    nom: "Akoufen La Botellerie",
    logo: "/assets/partners/2026/Akoufen-LaBotellerie_logo1-RVB-web.webp",
    lien: "https://www.akoufen.com",
    categorie: "prive",
  },
  {
    nom: "Fromagerie Rouet",
    logo: "/assets/partners/2026/Logo-Fromagerie-Rouet-F-Couleur.webp",
    lien: "https://fromagerie-cremerie-rouet.fr",
    categorie: "prive",
  },
  {
    nom: "Auto-école la Bonne Conduite",
    logo: "/assets/partners/2026/la_bonne_conduite.webp",
    lien: "https://auto-ecole.codesrousseau.fr/annuaire-auto-ecoles/brissac-quince/auto-ecole-la-bonne-conduite/6904",
    categorie: "prive",
  },
  {
    nom: "L'appart Fitness",
    logo: "/assets/partners/2026/Logo_l_appart_fitness.webp",
    lien: "https://clubs.lappartfitness.com/23-l-appart-fitness-brissac",
    categorie: "prive",
  },
  {
    nom: "Ouest Ouvrage",
    logo: "/assets/partners/2026/Logo_Ouest_Ouvrage.webp",
    lien: "https://www.ouest-ouvrage.com",
    categorie: "prive",
  },
  {
    nom: "MMA Brissac Quincé",
    logo: "/assets/partners/2026/Logo_MMA.jpg",
    lien: "https://agence.mma.fr/brissac-loire-aubance/",
    categorie: "prive",
  },
  {
    nom: "Exo Wakepark Anjou",
    logo: "/assets/partners/2026/Logo-Anjou-Wakepark.jpg",
    lien: "https://www.exoloisirs.com/fr/content/exo-49-awp",
    categorie: "prive",
  },
  {
    nom: "L'épicurien",
    logo: "/assets/partners/2026/Logo-epicurien.jpg",
    lien: "https://epicurien-restaurant-vauchretien.fr",
    categorie: "prive",
  },
  {
    nom: "Norauto",
    logo: "/assets/partners/2026/Logo-Norauto.png",
    lien: "https://centres.norauto.fr/maine-et-loire/brissac-quince/parc-activite-des-fontenelles",
    categorie: "prive",
  },
  {
    nom: "Pizz'Burg de Marcello",
    logo: "/assets/partners/2026/Logo-Marcello.webp",
    lien: "https://www.tripadvisor.fr/Restaurant_Review-g13415505-d27473847-Reviews-Le_Pizz_burg_De_Marcello-Brissac_Loire_Aubance_Maine_et_Loire_Pays_de_la_Loire.html",
    categorie: "prive",
  },
  {
    nom: "ImmoConcept 49",
    logo: "/assets/partners/2026/Logo-Immo-concept-49.webp",
    lien: "https://www.ic49.fr",
    categorie: "prive",
  },
  {
    nom: "Crédit Agricole",
    logo: "/assets/partners/2026/Credit_Agricole.webp",
    lien: "https://www.credit-agricole.fr/ca-anjou-maine/particulier.html",
    categorie: "prive",
  },
  {
    nom: "JCM Confort",
    logo: "/assets/partners/2026/JCM_Confort.webp",
    lien: "https://www.jcmconfort.fr",
    categorie: "prive",
  },
  {
    nom: "BigMat",
    logo: "/assets/partners/2026/BigMat.webp",
    lien: "https://www.bigmat.fr",
    categorie: "prive",
  },
  {
    nom: "Herve Energies",
    logo: "/assets/partners/2026/Herve_Energies.webp",
    lien: "https://herveenergies.site-solocal.com",
    categorie: "prive",
  },
];

export default partenaires2026;
